module.exports = __webpack_public_path__ + "img/user.ddf22e51.svg";